import { useT } from '../i18n/useT';
import { whyVenus as wvEn } from '../i18n/translations/en';
import { whyVenus as wvEs } from '../i18n/translations/es';
import './WhyVenus.css';

const stories = [
    "Casa Jacaranda",
    "Biundo's Italian Restaurant",
    "Chilorio Taqueria",
    "Taqueria Santoyo",
    "Wonder Woman Creations",
];

const WhyVenus = () => {
    const t = useT({ en: wvEn, es: wvEs });
    return (
        <>
            {/* Business Climate */}
            <section className="section" id="business-climate">
                <div className="container">
                    <div className="section-header text-center">
                        <span className="wv-label">{t.businessClimate.label}</span>
                        <h2 className="section-title">{t.businessClimate.title}<span>{t.businessClimate.titleSpan}</span></h2>
                        <p className="section-subtitle">{t.businessClimate.subtitle}</p>
                    </div>
                    <div className="wv-drone-wrap">
                        <img
                            src="/assets/images/venus-square-drone.jpeg"
                            alt="Venus Town Square aerial view"
                            className="wv-drone-photo"
                        />
                        <div className="wv-drone-caption">
                            <span>{t.businessClimate.photoCaption}</span>
                        </div>
                    </div>
                    <div className="wv-climate-cards">
                        {t.businessClimate.cards.map((card, i) => (
                            <div key={i} className="wv-climate-card">
                                <span className="wv-climate-icon">{card.icon}</span>
                                <h4>{card.title}</h4>
                                <p>{card.body}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Venus Living */}
            <section className="section section-alt" id="venus-living">
                <div className="container">
                    <div className="wv-two-col">
                        <div className="wv-image" style={{ backgroundImage: "url('/assets/images/venus-living.jpeg')" }}></div>
                        <div className="wv-content">
                            <span className="wv-label">{t.venusLiving.label}</span>
                            <h2 className="section-title">{t.venusLiving.title}<span>{t.venusLiving.titleSpan}</span></h2>
                            <p>{t.venusLiving.p1}</p>
                            <p>{t.venusLiving.p2}</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Affordability */}
            <section className="section" id="affordability">
                <div className="container">
                    <div className="section-header text-center">
                        <h2 className="section-title">{t.affordability.title}<span>{t.affordability.titleSpan}</span></h2>
                        <p className="section-subtitle">{t.affordability.subtitle}</p>
                    </div>
                    <div className="wv-price-cards">
                        <div className="wv-price-card">
                            <span className="wv-price-label">{t.affordability.ellisLabel}</span>
                            <span className="wv-price-sub">{t.affordability.ellisSubLabel}</span>
                            <span className="wv-price-value">$409,000</span>
                        </div>
                        <div className="wv-price-card">
                            <span className="wv-price-label">{t.affordability.johnsonLabel}</span>
                            <span className="wv-price-sub">{t.affordability.johnsonSubLabel}</span>
                            <span className="wv-price-value">$345,000</span>
                        </div>
                    </div>
                    <p className="wv-source">{t.affordability.source}</p>
                </div>
            </section>

            {/* Education */}
            <section className="section section-alt" id="education">
                <div className="container">
                    <div className="wv-two-col reverse">
                        <div className="wv-content">
                            <span className="wv-label">{t.education.label}</span>
                            <h2 className="section-title">{t.education.title}<span>{t.education.titleSpan}</span></h2>
                            <p>{t.education.p1}</p>
                            <p>{t.education.p2}</p>
                            <a href="https://www.venusisd.net/en-US" target="_blank" rel="noreferrer" className="btn btn-primary" style={{ marginTop: '1.5rem', display: 'inline-block' }}>
                                {t.education.cta}
                            </a>
                        </div>
                        <div className="wv-image" style={{ backgroundImage: "url('/assets/images/WhatsApp Image 2026-03-09 at 8.12.17 PM.jpeg')" }}></div>
                    </div>
                </div>
            </section>

            {/* Stories of Success */}
            <section className="section" id="stories">
                <div className="container">
                    <div className="section-header text-center">
                        <h2 className="section-title">{t.stories.title}<span>{t.stories.titleSpan}</span></h2>
                        <p className="section-subtitle">{t.stories.subtitle}</p>
                    </div>
                    <div className="wv-stories-grid">
                        {stories.map((s, i) => (
                            <div key={i} className="wv-story-card">
                                <div className="wv-story-icon">★</div>
                                <h3>{s}</h3>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default WhyVenus;
